import { useLocale, useTranslations } from 'next-intl'

import { THost } from '@/entities/room'
import { CertifiedBadge, EnglishCertifiedBadge, Profile } from '@/entities/user'

export const MobileUserInformation = ({
  picProfile,
  name,
  isCertificated,
  introduction,
}: THost) => {
  const locale = useLocale()
  const t = useTranslations('room_detail')

  const Badge = locale === 'en' ? EnglishCertifiedBadge : CertifiedBadge

  return (
    <div>
      <div className="flex gap-5 px-5 py-6 md:flex-row-reverse md:gap-3 md:p-0">
        <div className="grow md:pt-0.5">
          <span className="typo-body1-reading font-bold text-gray-900">
            {name}
          </span>
          {isCertificated && <Badge style={{ marginTop: '8px' }} />}
          <p className="typo-label1-reading mt-3 font-normal whitespace-break-spaces text-gray-600 md:hidden">
            {introduction}
          </p>
        </div>
        <div className="h-17 w-17 shrink-0 md:h-15 md:w-15">
          <Profile
            src={picProfile}
            alt={t('landlord_profile.profile_image', { name })}
            size={68}
            className="shrink-0"
            style={{ height: '100%', width: '100%' }}
            imageStyle={{ width: '100%' }}
          />
        </div>
      </div>
      <p className="typo-label1-reading mt-3 font-normal whitespace-break-spaces text-gray-600 max-md:hidden">
        {introduction}
      </p>
    </div>
  )
}
